<template>
  <footer class="bg-white dark:bg-gray-800">
    <div class="max-w-screen-xl p-4 py-6 mx-auto lg:py-16 md:p-8 lg:p-10">
      <!-- Main Footer Content -->
      <div class="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
        <!-- Company Info -->
        <div class="space-y-6">
          <img
            src="../../assets/images/logo-black.svg"
            class="h-10 dark:invert"
            alt="Academic Alerts Logo"
            width="180"
            height="45"
          />
          <p class="text-gray-600 dark:text-gray-400 text-sm">
            Empowering academics with timely updates and opportunities.
          </p>
          <div class="flex space-x-4">
            <a
              href="https://linkedin.com/company/academicalerts"
              target="_blank"
              class="text-gray-400 hover:text-primary"
            >
              <Icon name="mdi:linkedin" class="w-6 h-6" />
            </a>

            <a
              href="   https://www.instagram.com/academicalerts/"
              target="_blank"
              class="text-gray-400 hover:text-primary"
            >
              <Icon name="mdi:instagram" class="w-6 h-6" />
            </a>
          </div>
        </div>

        <!-- Quick Links -->
        <div>
          <h3
            class="text-sm font-semibold text-gray-900 uppercase dark:text-white mb-4"
          >
            Quick Links
          </h3>
          <ul class="space-y-3 text-gray-500 dark:text-gray-400">
            <li>
              <NuxtLink to="/about" class="hover:text-primary"
                >About Us</NuxtLink
              >
            </li>
            <li>
              <NuxtLink to="/buzz" class="hover:text-primary">Buzz</NuxtLink>
            </li>
            <li>
              <NuxtLink to="/events" class="hover:text-primary"
                >Events</NuxtLink
              >
            </li>
            <li>
              <NuxtLink to="/add" class="hover:text-primary"
                >Submit An  Event</NuxtLink
              >
            </li>
            <li>
              <NuxtLink to="/about/contact" class="hover:text-primary"
                >Contact</NuxtLink
              >
            </li>
          </ul>
        </div>

        <!-- Legal -->
        <div>
          <h3
            class="text-sm font-semibold text-gray-900 uppercase dark:text-white mb-4"
          >
            Legal
          </h3>
          <ul class="space-y-3 text-gray-500 dark:text-gray-400">
            <li>
              <NuxtLink to="/about/terms" class="hover:text-primary"
                >Terms of Service</NuxtLink
              >
            </li>
            <!-- <li>
              <NuxtLink to="/about/privacy" class="hover:text-primary"
                >Privacy Policy</NuxtLink
              >
            </li> -->
            <li>
              <NuxtLink to="/about/member" class="hover:text-primary"
                >Membership Policy</NuxtLink
              >
            </li>
          </ul>
        </div>

        <!-- Newsletter -->
        <div>
          <h3
            class="text-sm font-semibold text-gray-900 uppercase dark:text-white mb-4"
          >
            Find Events
          </h3>
          <p class="text-gray-600 dark:text-gray-400 text-sm mb-4">
            Search for upcoming academic events and opportunities.
          </p>
          <form class="flex gap-2" @submit.prevent="searchEvents">
            <input
              v-model="searchQuery"
              type="text"
              placeholder="Search events..."
              class="flex-1 px-4 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
            />
            <button
              type="submit"
              class="px-4 py-2 text-sm font-medium text-white bg-primary rounded-lg hover:bg-primary/90 flex items-center gap-2"
            >
              <Icon name="heroicons:magnifying-glass" class="w-4 h-4" />
              Search
            </button>
          </form>
        </div>
      </div>

      <hr class="my-8 border-gray-200 dark:border-gray-700" />

      <!-- Copyright -->
      <div class="text-center text-sm text-gray-500 dark:text-gray-400">
        <p class="capitalize">
          © {{ new Date().getFullYear() }} Academic Alerts - is a product of
          acadnetica solutions private limited. All Rights Reserved.
        </p>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
const subscribeNewsletter = () => {
  // Implement newsletter subscription logic
  console.log("Newsletter subscription triggered");
};

const router = useRouter();
const searchQuery = ref("");

const searchEvents = () => {
  if (searchQuery.value.trim()) {
    router.push({
      path: "/events",
      query: { search: searchQuery.value },
    });
  }
};
</script>
